// Shared by the visible contact details and the organization's structured data.
export const siteInfo = {
  name: "Begner",
  legalName: "SEO Begani",
  url: "https://begner.ch",
  email: "info@begner.ch",
  logoPath: "/apple-touch-icon.png",
  socialImagePath: "/social-preview-begner.png",
  address: {
    streetAddress: "Weiermattstrasse 4",
    postalCode: "4410",
    addressLocality: "Liestal",
    addressCountry: "CH",
  },
} as const;

export const socialProfiles = [
  { label: "Instagram", href: "https://www.instagram.com/begner2026/" },
  { label: "Facebook", href: "https://www.facebook.com/people/Begner/100069842456410/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/begner/" },
] as const;
